import * as Vuex from "vuex";
import Vue from "vue";

import { auth } from "./auth";
import { filter } from "./filter";
import { vehicle } from "./vehicle";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    filter,
    vehicle,
  },
});
